import { render, staticRenderFns } from "./DataProductQualityStatus.vue?vue&type=template&id=71b2b374&lang=pug"
import script from "./DataProductQualityStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataProductQualityStatus.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports